module.exports = __webpack_public_path__ + "img/big-icon-unsupported.d862a9dc.svg";